// @ts-nocheck
import {
    MBN_FILTERS_SAVED,
    MBN_TOURNAMENTS_RECEIVED,
    MBN_TOURNAMENTS_EDITED,
    MBN_TOURNAMENTS_UPDATE_ORIGINAL,
    MBN_MARKETS_UPDATE_ORIGINAL,
    MBN_MARKETS_RECEIVED,
    MBN_MARKETS_EDITED,
    MBN_TOURNAMENTS_RESET,
    MBN_TOURNAMENTS_FETCHING,
    MBN_MARKETS_FETCHING,
    MBN_TOURNAMENTS_CLEARED,
    MBN_MARKETS_RESET,
} from '../types';

const initialState = {
    filters: {},
    tournaments: [],
    tournamentsOriginal: [],
    tournamentMbnTemplates: [],
    tournamentMbnTemplatesOriginal: [],
    marketMbnTemplates: [],
    marketMbnTemplatesOriginal: [],
    tournamentsFetching: false,
    marketsFetching: false,
};

const mbn = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case MBN_FILTERS_SAVED: {
            return {
                ...state,
                filters: payload,
            };
        }
        case MBN_TOURNAMENTS_RECEIVED: {
            return {
                ...state,
                tournaments: payload.tournaments,
                tournamentsOriginal: payload.tournaments,
                tournamentMbnTemplates: payload.tournamentMbnTemplates,
                tournamentMbnTemplatesOriginal: payload.tournamentMbnTemplates,
            };
        }
        case MBN_TOURNAMENTS_EDITED: {
            return {
                ...state,
                ...getUpdatedTournaments(state, payload),
            };
        }
        case MBN_TOURNAMENTS_RESET: {
            return {
                ...state,
                tournaments: state.tournamentsOriginal,
                tournamentMbnTemplates: state.tournamentMbnTemplatesOriginal,
            };
        }
        case MBN_MARKETS_RESET: {
            return {
                ...state,
                marketMbnTemplates: state.marketMbnTemplatesOriginal,
            };
        }
        case MBN_TOURNAMENTS_CLEARED: {
            return initialState;
        }
        case MBN_TOURNAMENTS_UPDATE_ORIGINAL: {
            return {
                ...state,
                tournamentsOriginal: state.tournaments,
                tournamentMbnTemplatesOriginal: state.tournamentMbnTemplates,
            };
        }
        case MBN_MARKETS_UPDATE_ORIGINAL: {
            return {
                ...state,
                marketMbnTemplatesOriginal: state.marketMbnTemplates,
            };
        }
        case MBN_MARKETS_RECEIVED: {
            return {
                ...state,
                marketMbnTemplates: payload,
                marketMbnTemplatesOriginal: payload,
            };
        }
        case MBN_MARKETS_EDITED: {
            return {
                ...state,
                ...getUpdatedMarkets(state, payload),
            };
        }
        case MBN_TOURNAMENTS_FETCHING: {
            return {
                ...state,
                tournamentsFetching: payload,
            };
        }
        case MBN_MARKETS_FETCHING: {
            return {
                ...state,
                marketsFetching: payload,
            };
        }
        default:
            return state;
    }
};

const getUpdatedTournaments = (state, changes) => {
    let { tournaments, tournamentMbnTemplates } = state;
    const { source, target, items } = changes;
    const itemIds = items.map(item => item.id);

    if (source === 'all') {
        tournaments = tournaments.filter(trnmt => !itemIds.includes(trnmt.id));
    } else {
        tournamentMbnTemplates = tournamentMbnTemplates.map(tmpl => {
            if (source !== tmpl.mbnId) return tmpl;
            return {
                ...tmpl,
                tournaments: tmpl.tournaments.filter(trnmt => !itemIds.includes(trnmt.id)),
            };
        });
    }

    if (target === 'all') {
        tournaments = [...tournaments, ...items];
    } else {
        tournamentMbnTemplates = tournamentMbnTemplates.map(tmpl => {
            if (target !== tmpl.mbnId) return tmpl;
            return {
                ...tmpl,
                tournaments: [...tmpl.tournaments, ...items],
            };
        });
        //    .find(tmpl => tmpl.mbnId === target)?.tournaments.push(...items);
    }

    return {
        tournaments,
        tournamentMbnTemplates,
    };
};

const getUpdatedMarkets = (state, changes) => {
    let { marketMbnTemplates } = state;
    const { source, target, items } = changes;
    const itemIds = items.map(item => item.id);

    marketMbnTemplates = marketMbnTemplates.map(tmpl => {
        if (source === tmpl.mbnId) {
            return {
                ...tmpl,
                markets: tmpl.markets.filter(market => !itemIds.includes(market.id)),
            };
        } else if (target === tmpl.mbnId) {
            return {
                ...tmpl,
                markets: [...tmpl.markets, ...items],
            };
        } else return tmpl;
    });

    return {
        marketMbnTemplates,
    };
};

export default mbn;
